import { signalStore } from '@ngrx/signals';
import { withEntities } from '@ngrx/signals/entities';

import { withSelectedEntity } from '../../../shared/store/selected-entity.feature';
import { FinParcours } from '../../models/fin-parcours.model';
import { avecMéthodesFinsParcours } from './fin-parcours.methods';

export const FinParcoursStore = signalStore(
  { providedIn: 'root' },
  withEntities<FinParcours>(),
  withSelectedEntity(),
  avecMéthodesFinsParcours(),
);
